export enum NeedsSource {
  SAP = 'SAP',
  FISMOON = 'FISMOON'
}

export enum NeedsViewKey {
  BESI_IFA = 'BESI_IFA',
  FIS_MOON = 'FIS_MOON',
  FACTORY = 'FACTORY'
}

export const NEEDS_VIEW_TO_SOURCE: Partial<Record<NeedsViewKey, NeedsSource>> =
  {
    [NeedsViewKey.BESI_IFA]: NeedsSource.SAP,
    [NeedsViewKey.FIS_MOON]: NeedsSource.FISMOON
  };
